import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-banner',
  styleUrl: 'banner.css',
  shadow: true,
})
export class Banner {
  @Prop() bannerType: string = 'success';

  render() {
    return (
      <div class={`results ${this.bannerType}`}>
        <slot />
      </div>
    );
  }
}
